<template>
  <div
    id="bundle-input"
    class="w-[292px] h-[50px] p-[3px] border border-gray-200 rounded-md flex items-center justify-between select-none"
  >
    <div
      class="size-[42px] bg-gray-200/50 hover:bg-gray-200/75 flex items-center justify-center rounded-[3px] cursor-pointer"
      :class="prevButtonClasses"
      @click="handlePreviousClick"
    >
      <Icon
        name="Minus"
        :size="20"
        class="stroke-gray-800"
        :class="prevIconClasses"
      />
    </div>
    <div class="font-secondary font-medium text-[20px] leading-[26px]">
      {{ formatNumber(selectedItem?.maxUnits || 0) }} copyrights
    </div>
    <div
      class="size-[42px] bg-gray-200/50 hover:bg-gray-200/75 flex items-center justify-center rounded-[3px] cursor-pointer"
      :class="nextButtonClasses"
      @click="handleNextClick"
    >
      <Icon
        name="Plus"
        :size="20"
        class="stroke-gray-800"
        :class="nextIconClasses"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PlanItem } from '@/shared/graphql/legacy/generated'
import { formatNumber } from '@/shared/utils/number'
import { Icon } from '@dacr/ui'
import { computed } from 'vue'

const props = defineProps<{
  modelValue: string
  items: PlanItem[]
}>()

const emit = defineEmits(['update:modelValue'])

const selectedItem = computed(() =>
  props.items.find((item) => item.productId === props.modelValue)
)

const prevButtonClasses = computed(() => ({
  'bg-gray-200/25 pointer-events-none':
    props.items[0].productId === props.modelValue,
}))

const prevIconClasses = computed(() => ({
  'opacity-35': props.items[0].productId === props.modelValue,
}))

const nextButtonClasses = computed(() => ({
  'bg-gray-200/25 pointer-events-none':
    props.modelValue === props.items.at(-1)?.productId,
}))

const nextIconClasses = computed(() => ({
  'opacity-35': props.modelValue === props.items.at(-1)?.productId,
}))

const handlePreviousClick = () => {
  const selectedItemIndex = props.items.findIndex(
    (item) => item.productId === props.modelValue
  )
  const previousItem = props.items[Math.max(selectedItemIndex - 1, 0)]
  emit('update:modelValue', previousItem.productId)
}

const handleNextClick = () => {
  const selectedItemIndex = props.items.findIndex(
    (item) => item.productId === props.modelValue
  )
  const nextItem =
    props.items[Math.min(selectedItemIndex + 1, props.items.length)]
  emit('update:modelValue', nextItem.productId)
}
</script>
